export default function InvalidEnumValueException (message) {
  this.message = message
}
